module.exports = __webpack_public_path__ + "static/img/tup6.39790af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/tup6.png
// module id = FAku
// module chunks = 0